module.exports = __webpack_public_path__ + "img/about14.e7f616ee.jpg";